const modalOverlay = document.querySelector('.modal-overlay');
if(!modalOverlay) return;

function closeModal() {
  modalOverlay.classList.remove('modal-overlay-active');
}

// Close modal
modalOverlay.querySelector('.modal__close-button').onclick = closeModal;
modalOverlay.querySelector('.modal__button--decline').onclick = closeModal;
modalOverlay.onclick = closeModal;

// Prevent clicks inside the modal from closing it
modalOverlay.querySelector('.modal').onclick = function (event) {
  event.stopPropagation();
};

// Proceed to checkout
modalOverlay.querySelector('.modal__button--accept').addEventListener('click', function(){
  if (document.querySelector('.Form__CheckboxWrapper label') && document.querySelector('.Cart #cart_button_available .Cart__Checkout')) {
    document.querySelector('.Form__CheckboxWrapper label').click();
    document.querySelector('.Cart #cart_button_available .Cart__Checkout').click();
  }  
});

const termsAndConditions = document.querySelector('from.Drawer__Content Link--underline');

if (termsAndConditions) {
  termsAndConditions.addEventListener('click', function() {
    modalOverlay.classList.add('modal-overlay-active');
  });
}